import { r as h, p as d, h as o, H as c, g as b } from "./main-bb89b2f2.js";
import { c as n, d as f, l as g, C as a, r as u, b as p, g as r, e as m } from "./chart-tooltip-d075b66a-62f34707.js";
import "vue";
const y = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block;height:100%}.static{position:static}.relative{position:relative}", C = y, v = class {
  constructor(e) {
    h(this, e), this.data = void 0, this.label = void 0, this.unit = "", this.showLegend = !0, this.showTooltips = !0, this.legendPosition = void 0, this.labelLeft = 0, this.labelTop = 0, this.labelMaxWidth = 0;
  }
  dataWatcher(e) {
    const t = d(e);
    this.labels = t.labels, this.myChartInstance.data.labels = t.labels, this.myChartInstance.data.datasets = [
      {
        data: t.values,
        backgroundColor: n(),
        borderWidth: 2,
        borderColor: "#ffffff",
        hoverBackgroundColor: this.showTooltips ? f(15) : n(),
        hoverBorderWidth: 2,
        hoverBorderColor: "#ffffff"
      }
    ], this.myChartInstance.update();
  }
  componentDidLoad() {
    this.themeChangeObserver = g(() => {
      this.myChartInstance.data.datasets[0].backgroundColor = n(), this.myChartInstance.update();
    }), a.register(...u, p), a.defaults.font.family = "LiebherrText-Bold", a.defaults.font.size = 12, a.defaults.font.weight = "bold", this.canvas = this.hostElement.shadowRoot.querySelector("canvas");
    const e = {
      type: "doughnut",
      data: {
        labels: [],
        datasets: [
          {
            label: [],
            data: []
          }
        ]
      },
      options: {
        cutout: "70%",
        responsive: !0,
        maintainAspectRatio: !1,
        plugins: {
          legend: {
            display: this.showLegend,
            align: "center",
            title: {
              display: !1
            },
            labels: {
              boxHeight: 16,
              boxWidth: 16,
              textAlign: "left",
              font: {
                size: 12,
                weight: "bold"
              },
              generateLabels: (t) => {
                var i;
                return (i = this.labels) === null || i === void 0 ? void 0 : i.map((l, s) => ({
                  datasetIndex: s,
                  fillStyle: r(s),
                  strokeStyle: r(s),
                  text: `${l} ${t.data.datasets[0].data[s]}${this.unit}`
                }));
              }
            },
            position: this.legendPosition
          },
          tooltip: {
            enabled: !1,
            position: "nearest",
            alignment: "bottom",
            external: this.showTooltips ? m : null,
            callbacks: {
              label: (t) => `${t.label}: ${t.formattedValue}${this.unit}`
            }
          }
        }
      }
    };
    this.myChartInstance = new a(this.canvas, e), this.dataWatcher(this.data);
  }
  disconnectedCallback() {
    this.themeChangeObserver.disconnect();
  }
  render() {
    const e = this.hostElement.querySelector('[slot="innerAnnotation"]') != null;
    return o(c, { key: "a51689c5a4c8dc6a2a878ccab19bd97b364d9f94", style: { position: "relative" } }, o("canvas", { key: "d45e622c0d58b9fa51f8998ef69a2bfc16b8e72d" }), e && o("slot", { key: "845407ec88984ae01b92e3540fa37f40cefdde80", name: "innerAnnotation" }));
  }
  get hostElement() {
    return b(this);
  }
  static get watchers() {
    return {
      data: ["dataWatcher"]
    };
  }
};
v.style = C;
export {
  v as patternlib_donut_chart
};
